module.exports = new __parcel__URL__("home_other.9649e258.webp").toString();